import { useState } from "react";
import { FaArrowAltCircleDown, FaArrowAltCircleRight } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineLogout } from "react-icons/ai";
import logo from "../../asset/johura_logo.png";
import { getuser } from "../../components/CommonDateFormat";

const Sidebar = () => {
  const user = getuser();

  const [categoryMenuOpen, setCategoryMenuOpen] = useState(false);
  const [dealerMenuOpen, setDealerMenuOpen] = useState(false);
  const [supplierMenuOpen, setSupplierMenuOpen] = useState(false);
  const [purchaseMenuOpen, setPurchaseMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [salesMenuOpen, setSalesMenuOpen] = useState(false);
  const [transactionMenuOpen, setTransactionMenuOpen] = useState(false);
  const [reportMenuOpen, setReportMenuOpen] = useState(false);
  const [returnMenuOpen, setReturnMenuOpen] = useState(false);
  const [bankMenuOpen, setBankMenuOpen] = useState(false);
  const [ledgerMenuOpen, setLedgerMenuOpen] = useState(false);
  const [expenseMenuOpen, setExpenseMenuOpen] = useState(false);
  const [challanMenuOpen, setChallanMenuOpen] = useState(false);
  const [quotationMenuOpen, setQuotationMenuOpen] = useState(false);
  const [productServiceMenuOpen, setProductServiceMenuOpen] = useState(false);

  const [websiteMenuOpen, setWebsiteMenuOpen] = useState(false);

  const toggleProductServiceMenu = () => {
    setProductServiceMenuOpen(!productServiceMenuOpen);
  };
  const toggleCategoryMenu = () => {
    setCategoryMenuOpen(!categoryMenuOpen);
  };
  const toggleQuotationMenu = () => {
    setQuotationMenuOpen(!quotationMenuOpen);
  };
  const toggleDealerMenu = () => {
    setDealerMenuOpen(!dealerMenuOpen);
  };
  const toggleSupplierMenu = () => {
    setSupplierMenuOpen(!supplierMenuOpen);
  };
  const togglePurchaseMenu = () => {
    setPurchaseMenuOpen(!purchaseMenuOpen);
  };
  const toggleExpenseMenu = () => {
    setExpenseMenuOpen(!expenseMenuOpen);
  };
  const toggleUserMenu = () => {
    setUserMenuOpen(!userMenuOpen);
  };
  const toggleSalesMenu = () => {
    setSalesMenuOpen(!salesMenuOpen);
  };
  const toggleChallanMenu = () => {
    setChallanMenuOpen(!challanMenuOpen);
  };
  const toggleTransactionMenu = () => {
    setTransactionMenuOpen(!transactionMenuOpen);
  };
  const toggleReportMenu = () => {
    setReportMenuOpen(!reportMenuOpen);
  };
  const toggleReturnMenu = () => {
    setReturnMenuOpen(!returnMenuOpen);
  };
  const toggleBankMenu = () => {
    setBankMenuOpen(!bankMenuOpen);
  };
  const toggleLedgerMenu = () => {
    setLedgerMenuOpen(!ledgerMenuOpen);
  };
  const toggleWebSiteMenu = () => {
    setWebsiteMenuOpen(!websiteMenuOpen);
  };

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    navigate("/");
  };

  return (
    <div
      className={`bg-gray-900  text-white h-screen overflow-auto no-scrollbar p-4 hidden md:block shrink-0 w-[230px]`}
    >
      <h1 className="flex items-center gap-x-2 mb-6">
        <img src={logo} className="h-8" />
      </h1>

      <ul className="py-4 flex flex-col gap-2">
        <li>
          <a
            onClick={toggleSalesMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Sales Management
            {salesMenuOpen === false && <FaArrowAltCircleRight />}
            {salesMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              salesMenuOpen ? "block" : "hidden"
            }`}
          >
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/orders"}>Sales & Bill</Link>
            </li>
          </ul>
        </li>
        <li>
          <a
            onClick={toggleQuotationMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Quotation
            {quotationMenuOpen === false && <FaArrowAltCircleRight />}
            {quotationMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              quotationMenuOpen ? "block" : "hidden"
            }`}
          >
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/rate"}>Sales Rate</Link>
            </li> */}
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/quotation"}>Quotation Entry</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/quotation/items"}> Quotation List</Link>
            </li>
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/repeat"}> Sales Rate History</Link>
            </li> */}
          </ul>
        </li>
        <li>
          <a
            onClick={toggleChallanMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Challan
            {challanMenuOpen === false && <FaArrowAltCircleRight />}
            {challanMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              challanMenuOpen ? "block" : "hidden"
            }`}
          >
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/rate"}>Sales Rate</Link>
            </li> */}
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/challan"}>Challan Entry</Link>
            </li>
          </ul>
        </li>
        <li>
          <a
            onClick={toggleCategoryMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Product Management
            {categoryMenuOpen === false && <FaArrowAltCircleRight />}
            {categoryMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              categoryMenuOpen ? "block" : "hidden"
            } `}
          >
            <li className="hover:text-orange-600">
              <Link to="/dashboard/sub_category"> Brand</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to="/dashboard/product"> Product </Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to="/dashboard/models"> Models</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to="/dashboard/subjects"> Subjects</Link>
            </li>
          </ul>
        </li>
        {user?.role === "admin" && (
          <li>
            <a
              href="#"
              onClick={togglePurchaseMenu}
              className="flex items-center justify-between"
            >
              Purchase Management
              {purchaseMenuOpen === false && <FaArrowAltCircleRight />}
              {purchaseMenuOpen === true && <FaArrowAltCircleDown />}
            </a>
            <ul
              className={`ml-4 list-disc ${
                purchaseMenuOpen ? "block" : "hidden"
              }`}
            >
              <li className="hover:text-orange-600">
                <Link to={"/dashboard/purchase"}> Product Purchase</Link>
              </li>
            </ul>
          </li>
        )}
        <li>
          <a
            onClick={toggleReportMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Reports
            {reportMenuOpen === false && <FaArrowAltCircleRight />}
            {reportMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              reportMenuOpen ? "block" : "hidden"
            }`}
          >
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/report/purchase/daily"}>
                Daily Purchase Report
              </Link>
            </li> */}
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/report/purchase"}>
                Date-wise Purchase Report
              </Link>
            </li>
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/report/sales/daily"}>
                Daily Sales Report
              </Link>
            </li> */}
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/report/sales"}>Date-wise Sales Report</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/transaction/report"}>
                Transaction Report
              </Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/collection/report"}>Collection Report</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/payment/report"}>Payment Report</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/report/stock"}>Stock Report</Link>
            </li>
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/report/stock/purchase"}>
                Purchase Stock
              </Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/report/stock/sales"}>Sales Stock</Link>
            </li> */}
          </ul>
        </li>

        <li>
          <a
            onClick={toggleDealerMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Client Management
            {dealerMenuOpen === false && <FaArrowAltCircleRight />}
            {dealerMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              dealerMenuOpen ? "block" : "hidden"
            }`}
          >
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/dealer"}> Client Open</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/cash-receive"}>Client Collection</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/dealer-statement"}>Client Statement</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/dealer-summary"}>Client Summary</Link>
            </li>
            {user?.role == "sadmin" ? (
              <li className="hover:text-orange-600">
                <Link to={"/dashboard/pending-collection"}>
                  Pending Collection
                </Link>
              </li>
            ) : null}
          </ul>
        </li>
        <li>
          <a
            onClick={toggleSupplierMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Supplier Management
            {supplierMenuOpen === false && <FaArrowAltCircleRight />}
            {supplierMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              supplierMenuOpen ? "block" : "hidden"
            }`}
          >
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/supplier"}>Supplier Open</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/cash-payment"}>Supplier Payment</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/supplier-statement"}>
                Supplier Statement
              </Link>
            </li>
          </ul>
        </li>
        {/* <li>
          <a
            onClick={toggleLedgerMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Accounts Management
            {ledgerMenuOpen === false && <FaArrowAltCircleRight />}
            {ledgerMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc ${ledgerMenuOpen ? "block" : "hidden"}`}
          >
            {user?.role === "admins" && (
              <li>
                <Link to={"/dashboard/ledger-list"}> Ledger List</Link>
              </li>
            )}
            <li>
              <Link to={"/dashboard/account-page"}> Account Page</Link>
            </li>
            <li>
              <Link to={"/dashboard/dealer-statement"}>Dealer Statement</Link>
            </li>
            <li>
              <Link to={"/dashboard/supplier-statement"}>
                Supplier Statement
              </Link>
            </li>
          </ul>
        </li> */}

        {/* <li>
          <Link to={"/dashboard/manufacture"}>Manufacture Management</Link>
        </li> */}

        <li>
          <a
            onClick={toggleExpenseMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Expenses
            {expenseMenuOpen === false && <FaArrowAltCircleRight />}
            {expenseMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              expenseMenuOpen ? "block" : "hidden"
            }`}
          >
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/expenses/summary"}>Expenses Entry</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/expenses/item"}>Expenses Item</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/expenses/sub-item"}>Sub-Item</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/expenses/sub-item-list"}>
                Sub-Item List
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <a
            onClick={toggleProductServiceMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Product Service Center
            {productServiceMenuOpen === false && <FaArrowAltCircleRight />}
            {productServiceMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              productServiceMenuOpen ? "block" : "hidden"
            }`}
          >
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/rate"}>Sales Rate</Link>
            </li> */}
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/product-services"}>Product Service</Link>
            </li>
            {/* <li className="hover:text-orange-600">
              <Link to={"/dashboard/product-services/bills"}>
                {" "}
                Service Bills
              </Link>
            </li> */}
          </ul>
        </li>
        {/* {user?.role === "admin" && (
          <li>
            <a
              onClick={toggleTransactionMenu}
              href="#"
              className="flex items-center justify-between"
            >
              Sales Transaction
              {transactionMenuOpen === false && <FaArrowAltCircleRight />}
              {transactionMenuOpen === true && <FaArrowAltCircleDown />}
            </a>
            <ul className={`ml-4 ${transactionMenuOpen ? "block" : "hidden"}`}>
              <li>
                <Link to={"/dashboard/transaction"}>1. Sales Info</Link>
              </li>
              <li>
                <Link to={"/dashboard/pay"}>2. Pay Due History</Link>
              </li>
              <li>
                <Link to={"/dashboard/dealerDue"}>3. Dealer Transaction</Link>
              </li>
            </ul>
          </li>
        )} */}

        <li>
          <a
            onClick={toggleReturnMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Return & Damage
            {returnMenuOpen === false && <FaArrowAltCircleRight />}
            {returnMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              returnMenuOpen ? "block" : "hidden"
            }`}
          >
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/returnProduct"}> Sales Return</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/salesReturnList"}>Return Product List</Link>
            </li>
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/damageProduct"}>Damage Product</Link>
            </li>
          </ul>
        </li>
        {user?.email === "pixel@gmail.com" && (
          <li>
            <a
              onClick={toggleBankMenu}
              href="#"
              className="flex items-center justify-between"
            >
              Bank Transaction
              {bankMenuOpen === false && <FaArrowAltCircleRight />}
              {bankMenuOpen === true && <FaArrowAltCircleDown />}
            </a>
            <ul
              className={`ml-4 list-disc ${bankMenuOpen ? "block" : "hidden"}`}
            >
              <li className="hover:text-orange-600">
                <Link to={"/dashboard/bankinfo"}> Bank Info</Link>
              </li>
              <li className="hover:text-orange-600">
                <Link to={"/dashboard/bankdeposit"}>Bank Deposit</Link>
              </li>
            </ul>
          </li>
        )}
        {/* <li>
          <Link to={"/dashboard/warehouse"}>Warehouse Management</Link>
        </li> */}

        {user?.role === "admin" && (
          <li>
            <a
              onClick={toggleUserMenu}
              href="#"
              className="flex items-center justify-between"
            >
              User Management
              {userMenuOpen === false && <FaArrowAltCircleRight />}
              {userMenuOpen === true && <FaArrowAltCircleDown />}
            </a>
            <ul
              className={`ml-4 list-disc ${userMenuOpen ? "block" : "hidden"}`}
            >
              <li className="hover:text-orange-600">
                <Link to={"/dashboard/user"}> Manage User</Link>
              </li>
            </ul>
          </li>
        )}

        <li>
          <a
            onClick={toggleWebSiteMenu}
            href="#"
            className="flex items-center justify-between"
          >
            Website
            {websiteMenuOpen === false && <FaArrowAltCircleRight />}
            {websiteMenuOpen === true && <FaArrowAltCircleDown />}
          </a>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              websiteMenuOpen ? "block" : "hidden"
            }`}
          >
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/website/products"}>Products</Link>
            </li>
          </ul>
          <ul
            className={`ml-4 list-disc flex flex-col gap-y-1 ${
              websiteMenuOpen ? "block" : "hidden"
            }`}
          >
            <li className="hover:text-orange-600">
              <Link to={"/dashboard/website/contact"}>Message</Link>
            </li>
          </ul>
        </li>
      </ul>
      <button
        onClick={handleLogout}
        className="text-red-400  font-bold flex text-xl items-center gap-1"
      >
        Logout <AiOutlineLogout />
      </button>
    </div>
  );
};

export default Sidebar;
